import { HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.includes('viacep.com.br') || req.url.includes('ngx-viacep')) {
      return next.handle(req);
    }

    const httpRequest = req.clone({
      headers: new HttpHeaders({
        'Cache-Control': 'no-store, no-cache'
      })
    });

    return next.handle(httpRequest);
  }
}